import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import {
	LOCAL_STORAGE_TOKEN_KEY,
	LOCAL_STORAGE_USER_PHONE_NUMBER,
	TITLE_NAV,
	USER_INFO,
	LOCAL_STORAGE_TOKEN_ADMIN_CMS,
} from "../../../../configs/auth";
import { AppDispatch } from "../../../../app/store";
import { loginByHc } from "../auth/slice";
import * as CryptoJS from "crypto-js";

const CallBack = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();
	const [loading] = useState(true);
	const [searchParams] = useSearchParams();
	const user = searchParams.get("user");
	const order = searchParams.get("order");
	const redirect = searchParams.get("redirect");
	const date = searchParams.get("date");
	const antIcon = (
		<LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
	);

	useEffect(() => {
		if (!user) {
			navigate("/login");
		} else {
			const replaced = user.replaceAll(" ", "+");
			const key = process.env.REACT_APP_HASH_KEY || "";
			const decrypted = CryptoJS.AES.decrypt(replaced, key);
			var decryptUser = decrypted.toString(CryptoJS.enc.Utf8);
			console.log("USER:", decryptUser);

			if (decryptUser.length > 0) {
				const token_portal =
					localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY) ?? "";
				const phone_number =
					localStorage.getItem(LOCAL_STORAGE_USER_PHONE_NUMBER) ?? "";

				if (token_portal) {
					if (phone_number === decryptUser) {
						navigate("/");
					} else {
						localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
						localStorage.removeItem(LOCAL_STORAGE_USER_PHONE_NUMBER);
						localStorage.removeItem(USER_INFO);
						localStorage.removeItem(TITLE_NAV);
						localStorage.removeItem(LOCAL_STORAGE_TOKEN_ADMIN_CMS);
					}
				}
				dispatch(loginByHc(decryptUser as never))
					.then((value: any) => {
						if (!value.payload.success) {
							navigate("/login");
						} else {
							if (date) {
								return navigate(`/order-meals?date=${date}`);
							}

							if (!redirect) return navigate("/output-menu");
							console.log(redirect);
							navigate(`/${redirect}`);
						}
					})
					.catch((error) => {
						throw error;
					});
			} else {
				navigate("/login");
			}
		}
	}, [user, order]);

	return (
		<>
			<div>
				<Spin indicator={antIcon} spinning={loading} />
			</div>
		</>
	);
};

export default CallBack;
